/**
 * VerifyIdSection — standalone ID verification action, extracted out of
 * DocumentsSection so agents have a dedicated "Verify ID" bento tile
 * instead of hunting for it inside Documents. Matches ≥ 70% still
 * auto-file into the agent's "ID Documents" folder (backend side).
 * VerifyPhotoModule already renders its own "Verification history" log,
 * so this wrapper doesn't duplicate it.
 *
 * Rendered in the Property Admin Dashboard bento tile with `propertyId`
 * set, or standalone with just `agentId` for an agent's own ID on file.
 */
import VerifyPhotoModule from "@/components/modules/VerifyPhotoModule";

export default function VerifyIdSection({ agentId, propertyId }) {
  return (
    <div data-testid="verify-id-section">
      <VerifyPhotoModule
        config={{
          heading: "ID verification",
          subheading: "Upload an ID photo and a selfie — every attempt is saved to ID Documents, with a tick once it's a confirmed match.",
          instance_id: `verify-id-${agentId || propertyId || "self"}`,
          agent_id: agentId,
        }}
      />
    </div>
  );
}
